import React, { Component } from 'react';
import { component } from 'picoapp';
import ReactDOM from 'react-dom';
import ReactPlayer from 'react-player';
import { getClosest } from '@utils';

class PlayIcon extends Component {
  render(){ 
    return(
      <button className="Button Button--play" aria-label="play">
        <svg viewBox="0 0 20 20" className="icon" width="1em" height="1em">
          <use href="#play"></use>
        </svg>
      </button>
    )
  }
}

class MediaPlayer extends Component {
  constructor({el, appstate}) {
    super();
    this.el = el;
    this.ctx = appstate;
    this.identifier = el.dataset.identifier;
    this.state = { mediaUrl: '', playing: false };
    this.start = this.start.bind(this);
    this.pause = this.pause.bind(this);
    this.handlePause = this.handlePause.bind(this);
    this.bindEvents(el);
  }

  componentDidMount() {
    const { el } = this.props;
    
    this.setState({
      mediaUrl: el.dataset.videoUrl,
      cover: el.dataset.cover,
      playedInModal: false
    });

    this.parentController = getClosest(el, '.js-videoController');
    if (this.parentController) {
      this.parentController.addEventListener('isActive', () => {
        if(!this.state.playedInModal){
          this.setState({playedInModal: true})
        }
        this.start();
      })
      this.parentController.addEventListener('isInactive', this.pause.bind(this));
    }
  }

  bindEvents(el){
    this.ctx.on('video-slider-change', () => {
      this.setState({playing: false});
    })
    if(this.identifier == 'home-quiz'){

      const isInViewport = (el) => {
        
        const rect = el.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    
        );
      }
      document.addEventListener('scroll', () => {
        
          if( isInViewport(el) && !this.state.playing ){
            const preview = el.querySelector('.react-player__preview');
            if(preview){
              preview.click()
            } else {
              this.setState({playing: true});  
            }
          } 
          if( !isInViewport(el) && this.state.playing ){
            this.setState({playing: false});
          }
        
      }, {
          passive: true
      });
    }
  }

  start() {
    this.setState({ playing: true });
  }

  pause() {
    this.setState({ playing: false });
  }

 

  render() {
    const { mediaUrl, playing, playedInModal } = this.state;
    if (!mediaUrl) {
      return null;
    }
    return (
      <ReactPlayer
        className="media-player"
        url={mediaUrl}
        playing={playing}
        width="100%"
        height="100%"
        onPause={this.handlePause}
        light={this.state.cover ? this.state.cover : playedInModal ? false : true }
        playIcon={<PlayIcon />}
        onClickPreview={() => this.setState({ playing: true })}
        controls={true}
        config={{
          youtube: {
            playerVars: {
              modestbranding: 1,
              showinfo: 0,
            },
          },
          vimeo: {
            playerOptions: {
              responsive: true,
            },
          },
        }}
      />
    );
  }

  handlePause() {
    if (this.parentController) {
      const isPaused = new CustomEvent('isPaused');
      this.parentController.dispatchEvent(isPaused);
    }
  }
}

export default component((node, ctx) => {
  const element = <MediaPlayer appstate={ctx} el={node} />;
  ReactDOM.render(element, node);

  // Unmount component on Pjax navigation
  return function () {
    try {
      ReactDOM.unmountComponentAtNode(node);
    } catch (e) {
      console.error(e);
    }
  };
});
